import useBulkCollectionEventData from "../hooks/useBulkCollectionEventData"

interface Props {
  eventIds: string[]
  skipLocation?: boolean
}

const EventDataFetcher: React.FC<Props> = (props: Props) => {
  const { eventIds, skipLocation } = props

  useBulkCollectionEventData({ eventIds, skipLocation })

  return null
}

export default EventDataFetcher
